import script from "./activeChestView.vue?vue&type=script&setup=true&lang=ts"
export * from "./activeChestView.vue?vue&type=script&setup=true&lang=ts"

import "./activeChestView.vue?vue&type=style&index=0&id=3996ef52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3996ef52"]])

export default __exports__